export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe8b946fdd8243217fee0a38c9f517b49cf129865&name=fetchTypeahead!'